import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};

export const roleAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // const expectedRole = route.data['expectedRole'];
  const expectedRoles: number[] = route.data['expectedRole'];
  const userRole = authService.getRoleId();

  if (authService.isAuthenticated() && expectedRoles.includes(userRole)) {
    console.log("can access",userRole)
    return true;
  } else {
    console.log("No access",userRole)
    router.navigate(['/login']);
    return false;
  }
};
